import React from 'react';

import { Stack, Typography } from '@gogame/components';

export default ({ event, data, eventCompletionRealCountry }) => {
  return {
    color: 'info',
    date: data.eventCompletionDate,
    dateTemplate: 'LL',
    lastDayEvent: true,
    title: (
      <Typography>
        <Stack as={'span'} spacing={1.5} direction={'row'}>
          <span>{`Recurrent Event: ${event.name}`}</span>
          <span>•</span>
          <span>{`Completions: ${data.eventCompletionsCount}`}</span>
          <span>•</span>
          <span>{`Country: ${eventCompletionRealCountry}`}</span>
        </Stack>
      </Typography>
    ),
  };
};
